import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21.116 19.799"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "m12.521 16.612-1.237-3.093a.66.66 0 0 0-.675-.408l-2.13.213a10.13 10.13 0 0 1 0-6.852l2.13.213a.65.65 0 0 0 .675-.408l1.234-3.097a.66.66 0 0 0-.143-.705.7.7 0 0 0-.116-.091L9.784.836a.66.66 0 0 0-.812.092 12.686 12.686 0 0 0 0 17.943.66.66 0 0 0 .811.092l2.475-1.547a.664.664 0 0 0 .263-.805Z" }),
      _createElementVNode("path", {
        d: "M17.229 10.658a.467.467 0 0 0 0-.664l-2.658-2.656a.467.467 0 0 0-.662 0l-.439.445a.467.467 0 0 0 0 .662l1.882 1.883-1.883 1.883a.467.467 0 0 0 0 .662l.441.441a.467.467 0 0 0 .662 0Zm3.75-.664-2.656-2.656a.467.467 0 0 0-.662 0l-.438.438a.467.467 0 0 0 0 .662l1.879 1.886-1.879 1.883a.467.467 0 0 0 0 .662l.441.441a.467.467 0 0 0 .662 0l2.653-2.656a.464.464 0 0 0 0-.66",
        "data-name": "icon"
      })
    ], -1)
  ]))]))
}
export default { render: render }